<template>
  <div>
    <v-row class="mb-7">
      <v-col lg="6" class="py-0">
        <v-toolbar flat style="background: transparent">
          <h2>On-Demand Report</h2>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
      <v-col lg="6" class="py-0">
        <v-toolbar flat style="background: transparent" class="content-right">
          <v-btn
          @click="goToCourseDetail"
          elevation="0"
          class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
        >
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseReport.courseDetail'
            )
          }}
        </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <div class="bg-custom py-7">
      <v-row>
        <v-col class="ml-5 xs-full-width text-right">
          <!-- <downloadexcel :fetch="exportCertification" :fields="json_fields" :name="fileExcelName" class="clickable pl-5 pr-5 mr-5 xs-full-width font-weight-light body-2 button-secondary v-btn theme--light elevation-0 v-size--default">
                    <v-icon left class="icon-color-inherit">mdi-microsoft-excel</v-icon>Export Report
                </downloadexcel>-->
          <v-btn
            @click="exportCertification"
            class="clickable pl-5 pr-5 mr-5 xs-full-width font-weight-light body-2 button-secondary v-btn theme--light elevation-0 v-size--default"
          >
            <v-icon left class="icon-color-inherit">mdi-microsoft-excel</v-icon
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.courseReport.export')
            }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items-per-page="params.limit"
        :hide-default-header="false"
        hide-default-footer
        :items="users"
        class="pa-mb-5 mx-3 font-weight-light table-haveboder"
      >
        <!-- <template v-slot:header="{ props }">
                <thead class="v-data-table-header">
                    <tr>
                        <th style=" border-right: thin solid rgba(0, 0, 0, .12);" v-for="(item,index) in props.headers" :key="index">
                            <div class="start">{{item.text}}</div>

                        </th>

                    </tr>

                </thead>
            </template> -->
        <!-- <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.username }}</td>
            <td>{{ item.fullName }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.school }}</td>
            <td v-for="(item_his, index) in item.history" :key="index">
              {{ item_his.percent }}
            </td>
          </tr>
        </template> -->
      </v-data-table>
      <div class="pt-3 pr-3 pb-5 text-center">
        <v-pagination
          v-model="params.page"
          :length="pageCount"
          @input="changePage"
          color="rgb(66, 154, 216)"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
//import downloadexcel from "vue-json-excel";
import { getCourseById } from '@/service/course/course';
import { getUserOndemand } from '@/service/course/report';
export default {
  components: {
    // downloadexcel
  },
  data() {
    return {
      loading: false,
      fileExcelName: 'ondemand.xls',
      users: [],
      params: {},
      initHeaders: [
        {
          text: 'USERNAME',
          align: 'start',
          sortable: false,
          value: 'username',
          width: 100,
        },
        {
          text: 'NAME',
          value: 'fullName',
          align: 'start',
          sortable: false,
          width: 100,
        },
        {
          text: 'EMAIL',
          value: 'email',
          align: 'start',
          sortable: false,
          width: 100,
        }
      ],
      headers: [
        {
          text: 'USERNAME',
          align: 'start',
          sortable: false,
          value: 'username',
          width: 100,
        },
        {
          text: 'NAME',
          value: 'fullName',
          align: 'start',
          sortable: false,
          width: 100,
        },
        {
          text: 'EMAIL',
          value: 'email',
          align: 'start',
          sortable: false,
          width: 100,
        },
        // {
        //   text: 'ORGANIZATION',
        //   value: 'school',
        //   align: 'start',
        //   sortable: false,
        //   width: 100,
        // },
      ],
      json_fields: {},
      lecture_arr: [],
      itemLectures: [],
      courseName: '',
    };
  },
  methods: {
    async initialize() {
      this.params = {
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 100,
        active: null,
        course: this.$route.query.id,
      };
      let course = {
        id: this.$route.query.id,
      };
      await this.getCourseDetail(course);
      await this.getOndemandReport();
    },
    async getOndemandReport() {
      this.loading = true;
      this.users = [];
      let result = await getUserOndemand(this.params);
      this.loading = false;
      this.pageCount = result.maxPage;
      this.headers = [...this.initHeaders]
      if (result.lectures) {
        this.itemLectures = result.lectures;
        this.itemLectures.forEach((lect) => {
          this.headers.push({
            text: lect.title + '(%)',
            align: 'start',
            sortable: false,
            value: lect._id,
            width: 100,
          });
        });
        this.headers.push({
          text: 'Total',
          align: 'start',
          sortable: false,
          value: 'total',
          width: 100,
        });
      }

      await result.data.forEach(async (user) => {
        let items = [];
        let lectures = [];
        let allPercent = 0;
        if (user.history) {
          this.itemLectures.forEach((lecture) => {
            items = user.history.filter(
              (history) => history.lecture === lecture._id
            );
            if (items.length > 0) {
              let percents = 0;
              items.forEach((value) => {
                percents += value.percent;
              });
              lectures[lecture._id] = percents;
            } else {
              lectures[lecture._id] = 0;
            }
            allPercent += lectures[lecture._id];
          });
        }
        let totalPercent =
          (allPercent / (this.itemLectures.length * 100)) * 100;
        this.users.push({
          fullName: user.student.firstName + ' ' + user.student.lastName,
          email: user.student.email,
          username: user.student.username,
          ...lectures,
          total: Number.isInteger(totalPercent)
            ? totalPercent + '%'
            : totalPercent.toFixed(2) + '%',
        });
      });
    },
    async getCourseDetail(param) {
      let detail = await getCourseById(param);
      this.courseName = detail ? detail.title : 'ondemand';
      console.log('detail', detail);
      // this.lecture_arr = [];
      // console.log('detail.sections');
      // console.log(detail.sections);
      //console.log('detail', detail.sections[0]);
      // if (detail.sections.length > 0) {
      //   detail.sections.forEach((element) => {
      //     let lecture = element.lectures.filter(function (lecture) {
      //       if (lecture.video.length > 0) {
      //         return lecture;
      //       }
      //     });
      //     this.lecture_arr.push(lecture);
      //   });
      // }
      // console.log('this.lecture_arr');
      // console.log(this.lecture_arr);
      // for (let i = 0; i < this.lecture_arr.length; i++) {
      //   for (let j = 0; j < this.lecture_arr[i].length; j++) {
      //       // this.headers.push({
      //       //   text: this.lecture_arr[i][j].title + `(%)`,
      //       //   align: 'start',
      //       //   sortable: false,
      //       //   value: this.lecture_arr[i][j]._id,
      //       //   width: 100,
      //       // });
      //   }
      // }
    },
    async changePage(page) {
      this.params.page = page;
      await this.getOndemandReport();
    },
    async exportCertificationOld() {
      // for (let k = 0; k < this.headers.length; k++) {
      //     console.log('this.headers[k].text', this.headers[k].text)
      //     this.json_fields[this.headers[k].text] = this.headers[k].text
      // }
      // console.log('this.json_fields', this.json_fields)
      const result = await getUserOndemand({
        ...this.params,
        limit: 1000,
        page: 1,
      });
      let users = [];

      for (let i = 0; i < result.data.length; i++) {
        let info = {
          username: result.data[i].student.username,
          fullname:
            result.data[i].student.firstName +
            ' ' +
            result.data[i].student.lastName,
          email: result.data[i].student.email,
          //school: result.data[i].student.school,
        };

        console.log('result.data[i].history', result.data[i].history);

        for (let j = 0; j < result.data[i].history.length; j++) {
          info[`live` + (j + 1)] = result.data[i].history[j].percent;
          console.log('info', info);
        }
        users.push(info);
      }
      const dataWS = XLSX.utils.json_to_sheet(users);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, this.courseName + `_` + `OndemandReport` + `.xlsx`);

      // return users;
    },
    async exportCertification() {
      // fetch
      const result = await getUserOndemand({
        ...this.params,
        limit: 1000,
        page: 1,
      });
      let itemLectures = []
      let headers = []
      let usersResult = []

      if (result.lectures) {
        itemLectures = result.lectures;
        itemLectures.forEach((lect) => {
          headers.push({
            text: lect.title + '(%)',
            align: 'start',
            sortable: false,
            value: lect._id,
            width: 100,
          });
        });
        headers.push({
          text: 'Total',
          align: 'start',
          sortable: false,
          value: 'total',
          width: 100,
        });
      }

      await result.data.forEach(async (user) => {
        let items = [];
        let lectures = [];
        let allPercent = 0;
        if (user.history) {
            itemLectures.forEach((lecture) => {
            items = user.history.filter(
              (history) => history.lecture === lecture._id
            );
            if (items.length > 0) {
              let percents = 0;
              // items.forEach((value) => {
              //   percents += value.percent;
              // });
              if(items.length > 0){
                percents += items[0].percent
              }
              lectures[lecture._id] = percents;
            } else {
              lectures[lecture._id] = 0;
            }
            allPercent += lectures[lecture._id];
          });
        }
        let totalPercent =
          (allPercent / (itemLectures.length * 100)) * 100;
        usersResult.push({
          fullName: user.student.firstName + ' ' + user.student.lastName,
          email: user.student.email,
          username: user.student.username,
          ...lectures,
          total: Number.isInteger(totalPercent)
            ? totalPercent + '%'
            : totalPercent.toFixed(2) + '%',
        });
      });
      //end fetch
      let itemUsers = usersResult;

      
      let users = []
      itemUsers.forEach((element, idex) => {
        let keys = Object.keys(element);
        let item = [];
        itemLectures.forEach((lect) => {
          if (keys.includes(lect._id)) {
            item[lect.title + '(%)'] = element[lect._id];
          }
        });
        users.push({
          fullName: element.fullName,
          email: element.email,
          username: element.username,
          ...item,
          total: element.total,
        });
      });
      const dataWS = XLSX.utils.json_to_sheet(users);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, this.courseName + `_` + `OndemandReport` + `.xlsx`);
      // return users;
    },
    goToCourseDetail(){
      this.$router.push({
          path: '/course/detail',
          query: {
            id: this.$route.query.id,
            step: 1,
        }
      });
    }
  },
  async mounted() {
    await this.initialize();
  },
};
</script>

<style scoped>
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

th div {
  /*display: inline-block;
    vertical-align: bottom;*/

  width: 100%;
  max-width: 100px;

  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  direction: rtl;
  text-align: left;
}
</style>
<style lang="scss">
  .content-right {
    .v-toolbar__content, .v-toolbar__extension {
      justify-content: flex-end;
    }
  }
</style>
